import React from 'react';
import { Link } from 'react-router-dom';
import { translations } from '../data/translations';
import { ArrowUpRight } from 'lucide-react';

const PortfolioSection = ({ lang }) => {
  const t = translations[lang].portfolio;
  
  return (
    <section id="portfolio" className="bg-[#121212] py-24 md:py-32">
      <div className="max-w-5xl mx-auto px-6 lg:px-16">
        {/* Section Label */}
        <div className="mb-6">
          <span className="text-[#00FFD1] text-sm font-medium tracking-wider uppercase">
            {t.label}
          </span>
        </div>
        
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-[-0.02em] mb-12">
          {t.title}
        </h2>
        
        {/* Project Cards */}
        <div className="grid gap-8">
          {t.projects.map((project) => (
            <div
              key={project.id}
              className="bg-black border border-white/25 p-8 md:p-12 group hover:border-[#00FFD1]/40 transition-all duration-400"
            >
              {/* Flagship Label */}
              {project.isFlagship && (
                <div className="mb-6">
                  <span className="inline-flex items-center px-3 py-1 bg-[#00FFD1]/10 text-[#00FFD1] text-xs font-medium tracking-wider uppercase">
                    {project.label}
                  </span>
                </div>
              )}
              
              {/* Project Name */}
              <h3 className="text-2xl md:text-3xl font-semibold text-white mb-4">
                {project.name}
              </h3>
              
              {/* Description */}
              <p className="text-lg text-white/85 font-normal leading-relaxed mb-8 max-w-2xl">
                {project.description}
              </p>
              
              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4">
                <Link
                  to="/eqtos"
                  className="inline-flex items-center justify-between gap-3 bg-[#00FFD1] text-black px-6 py-4 text-base font-medium hover:bg-[#00FFD1]/90 transition-all duration-400 ease-in-out group/btn"
                >
                  {project.cta}
                  <ArrowUpRight className="w-5 h-5 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform duration-300" />
                </Link>
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-between gap-3 bg-white/10 text-white px-6 py-4 text-base font-medium hover:bg-white hover:text-black transition-all duration-400 ease-in-out group/btn"
                >
                  eqtos.tech
                  <ArrowUpRight className="w-5 h-5 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform duration-300" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
